import { lazy } from 'react';

const WEDDING_PARTY = lazy(() => import('../../../PublicWebsite/pages/WeddingParty'));
const POI = lazy(() => import('../../../PublicWebsite/pages/PoiV2'));
const FAQ = lazy(() => import('../../../PublicWebsite/pages/Faq'));
const REGISTRY = lazy(() => import('../../../PublicWebsite/pages/Registry'));
const PHOTO = lazy(() => import('../../../PublicWebsite/pages/Photos'));
const TRAVEL = lazy(() => import('../../../PublicWebsite/pages/Travel'));
const EVENT = lazy(() => import('../../../PublicWebsite/pages/Events'));
const HOME = lazy(() => import('../../../PublicWebsite/pages/Home'));
const RSVP = lazy(() => import('../../../PublicWebsite/pages/Rsvp'));
const GUEST_MANAGER_EVENT = lazy(() =>
  import('pages/Events/EventPreview/components/WebsitePreviewEmbeddedEvents')
);
const VIRTUAL_EVENT = lazy(() =>
  import('components/manage/VirtualEvents/ZoomEdit/components/VirtualEventPreview')
);

export {
  WEDDING_PARTY,
  POI,
  FAQ,
  REGISTRY,
  PHOTO,
  TRAVEL,
  HOME,
  EVENT,
  RSVP,
  GUEST_MANAGER_EVENT,
  VIRTUAL_EVENT,
};



// WEBPACK FOOTER //
// ./src/components/manage/website/WebsitePreview/helper.js